export interface PlanBullet {
  text: string
  detail?: string
}

// Preço cheio do plano Start e a condição especial de parceiro.
export const START_FULL_PRICE = 99
export const START_OFFER_PRICE = 49.5

export const START_DESCRIPTION = 'Gestão inteligente que cabe no seu bolso.'

// Benefícios do Start. O "50 recebimentos grátis" foi promovido a destaque
// próprio no card (FreeBillingsHighlight), então não se repete aqui.
export const START_OFFER_BULLETS: PlanBullet[] = [
  { text: 'Cobrança direto no WhatsApp' },
  { text: 'Página de Vendas para Crescer' },
  { text: 'Assinatura Eletrônica de Contratos' },
  { text: 'Emissão de Nota Fiscal e Negativação' },
  { text: 'Portal de Clientes' },
  { text: 'Módulo de Contas a Pagar' },
  { text: 'Assistente de AI' },
  { text: 'API e webhooks para integração' }
]
